module.exports = __webpack_public_path__ + "img/blue_029.ce5a5646.png";